import { styled } from '@mui/system';
import { Box } from '@mui/material';
import {
  TwoColumnLayout,
  StepCard,
  NumberIcon,
  CardTitle,
  CardDescription,
  SectionImage,
} from '../../Pages/Auth/Splash/styles';

export const TwoColumnLayoutCentered = styled(TwoColumnLayout)(({ theme }) => ({
  marginBottom: '48px',
  [theme.breakpoints.up('md')]: {
    alignItems: 'center',
  },
  [theme.breakpoints.down(950)]: {
    flexDirection: 'column',
  },
}));
export const StepCardSectionImage = styled(SectionImage)(({ theme }) => ({
  maxWidth: '520px',
  [theme.breakpoints.down(950)]: {
    maxWidth: '600px',
    width: '100%',
  },
}));
export const CardsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
  [theme.breakpoints.down('md')]: {
    gap: '14px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '12px',
  },
}));

export const StepCardRow = styled(StepCard)(({ theme }) => ({
  width: '100%',
  height: '100%',
  maxWidth: '600px',
  gap: '20px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
}));

export const NumberIconResponsive = styled(NumberIcon)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginBottom: '8px',
    width: '100%',
  },
  [theme.breakpoints.up('sm')]: {
    marginBottom: 0,
  },
}));

export const CardContentWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  gap: '10px',
  [theme.breakpoints.down('sm')]: {
    gap: '8px',
  },
}));

export const StepCardTitle = styled(CardTitle)(({ theme }) => ({
  fontSize: '20px',
  [theme.breakpoints.down('md')]: {
    fontSize: '17px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}));

export const StepCardDescription = styled(CardDescription)(({ theme }) => ({
  fontSize: '14px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '13px',
  },
}));
